import React from 'react'

import { usePermissions } from '../../hooks/usePermissions'
import { ResidentUserAuthLevel } from '../../../common/validations'

export interface PermissionsProps {
  feature:
    | 'payments'
    | 'terminateContract'
    | 'contractChanges'
    | 'contractDocument'
  isVisible?: boolean
  fallback?: React.ReactNode
  children: React.ReactNode
}

export const Permissions: React.FC<PermissionsProps> = ({
  feature,
  children,
  fallback = null,
  isVisible = true,
}) => {
  const { permissions, authLevel } = usePermissions()

  if (!isVisible || !permissions) {
    return null
  }

  const isStronglyAuthenticated = authLevel === ResidentUserAuthLevel.STRONG

  switch (feature) {
    case 'payments':
      if (
        isStronglyAuthenticated &&
        (permissions.tenantRoles.includes('contractParty') ||
          permissions.tenantRoles.includes('payer'))
      ) {
        return children
      }
      break
    case 'terminateContract':
      if (
        isStronglyAuthenticated &&
        permissions.tenantRoles.includes('contractParty')
      ) {
        return children
      }
      break
    case 'contractChanges':
      if (isStronglyAuthenticated) {
        return children
      }
      break
    case 'contractDocument':
      if (
        isStronglyAuthenticated &&
        permissions.tenantRoles.includes('contractParty')
      ) {
        return children
      }
      break
    default:
      return fallback
  }
  return fallback
}
